// extracted by mini-css-extract-plugin
module.exports = {"control":"SetupQuestionsControl_control__Q39B9"};